import { Component } from '@angular/core';

@Component({
    selector: 'app-digi4school-information',
    templateUrl: './digi4school-information.component.html',
    styleUrls: ['./digi4school-information.component.scss'],
    standalone: true
})
export class Digi4schoolInformationComponent {

}
